<template>
  <el-select
    ref="select"
    v-model="value"
    v-bind="params.selectProps"
    @change="changeValue"
    @visible-change="onVisibleChange"
  >
    <template v-if="params.isGroup">
      <el-option-group
        v-for="group in params.options"
        :key="group.label"
        :label="group.label"
      >
        <el-option
          v-for="(item,index) in group.options"
          :key="index"
          :label="item[params.tagName]"
          :value="item[params.tagValue]"
        />
      </el-option-group>
    </template>
    <template v-else>
      <el-option
        v-for="(item,index) in params.options"
        :key="index"
        :label="item[params.tagName]"
        :value="item[params.tagValue]"
      />
    </template>
  </el-select>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'CargoAgGridSelectEditor',
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    this.value = this.params.value
    this.$refs.select.focus()
  },
  methods: {
    //
    getValue() {
      return this.value
    },
    onVisibleChange(value) {
      if (!value) {
        this.params.api.stopEditing()
      }
    },
    changeValue(value) {
      this.onVisibleChange(value)
    }
  }
})
</script>

<style>
</style>
